module.exports = __webpack_public_path__ + "static/media/golden-egg.e1cfbc21.png";